import { QRCodeProductBarsLine } from 'Components/lines/qrcode-product-bars-line/QRCodeProductBarsLine';
export default QRCodeProductBarsLine;
